import { recordClick, recordCustomEvent } from './actions'
import { getViewport } from './viewportListener'

let percentiles = [25, 50, 75]
let registeredVideos = {}
let trackVideoControls = false

/**
 * @param {number[] | null} [customPercentiles]
 * @param {boolean} [enableVideoControlsTracking]
 */
export default (customPercentiles = null, enableVideoControlsTracking) => {
  if (customPercentiles) percentiles = customPercentiles
  trackVideoControls = enableVideoControlsTracking


  /** @type {TeardownFunction} */
  let teardown
  /** @type {MutationCallback} */
  const callBack = (mutationsList, observer) => {
    if (typeof (window.videojs) !== 'undefined') {
      window.videojs.registerPlugin('tealiumTagging', videoPlugin.bind(this))
      teardown = watchForVideos()
      observer.disconnect()
    }
  }
  let observer = new MutationObserver(callBack)
  observer.observe(document.head, { attributes: true, childList: true, subtree: true })

  return () => {
    observer.disconnect()
    if (teardown) teardown()
  }
}

/**
 * @returns {TeardownFunction}
 */
const watchForVideos = () => {
  /** @type {MutationCallback} */
  const callBack = (mutationsList) => {
    let checkForVideos = false
    mutationsList.map(mutation => {
      if ( mutation.type === 'childList' && mutation.addedNodes.length ) {
        const { addedNodes } = mutation
        const nodes = Array.prototype.slice.call(addedNodes)
        nodes.map(node => {
          let videos = node.querySelectorAll ? node.querySelectorAll('video[src]') : []
          if (videos.length) checkForVideos = true
        })
      }

      if ( mutation.type === 'attributes' && mutation.target.nodeName === 'VIDEO' ) checkForVideos = true
    })

    if (checkForVideos) getAndRegisterVideos()
  }

  getAndRegisterVideos()
  const observer = new MutationObserver(callBack)
  observer.observe(document.body, { attributes: true, childList: true, subtree: true })

  return () => {
    observer.disconnect()
  }
}

const getAndRegisterVideos = () => {
  let newVideos = {}
  const videos = Array.prototype.slice.call(document.querySelectorAll('video[src]'))
  videos.map(video => {
    const { id } = video
    if (id) {
      newVideos[id] = registeredVideos[id] || createPlayer(id)
    } else {
      console.log('Video is missing an Id')
    }
  })
  registeredVideos = newVideos
}

const createPlayer = id => {
  const player = videojs(id)
  const element = document.getElementById(id)

  player.tealiumTagging({
    player,
    percentiles,
    trackPlay: true,
    trackPause: true,
    trackEnded: true,
    trackPercent: true,
    selectorName: element.getAttribute('data-selector-name') || undefined,
    customSelectorName: element.getAttribute('data-custom-selector-name') || undefined,
    el: element.getAttribute('data-ga-event-label') || undefined
  })
  return player
}

const videoPlugin = ({
  player,
  percentiles,
  trackPlay,
  trackPause,
  trackEnded,
  trackPercent,
  selectorName = 'video_action',
  customSelectorName = 'video_action_custom',
  el
}) => {
  let percentTriggered = {}
  let videoStartedFlag = false

  percentiles.map(percentile => {
    percentTriggered['x' + percentile] = false
  })

  if (trackPlay === true) player.on('play', processEvent)
  if (trackPause === true) player.on('pause', processEvent)
  if (trackEnded === true) player.on('ended', processEvent)

  if (trackPercent === true) {
    player.on('timeupdate', calculatePercent)
    player.on('percent', processEvent)
  }

  function processEvent ({ type }, data) {
    let videoEventName

    if (trackPlay) {
      switch(type) {
        case 'play':
          if (videoStartedFlag === false) {
            videoEventName = 'Play'
          } else {
            videoEventName = 'Replay'
          }
          videoStartedFlag = true
          break;
        case 'pause':
          videoEventName = 'Pause'
          break;
        case 'ended':
          videoEventName = 'Complete'
          break;
        case 'percent':
          videoEventName = data + 'pct'
          break;
      }
    }

    recordCustomEvent(videoEventName === 'Play' ? selectorName : customSelectorName, {
      elementId: el,
      action: getViewport() ? `${videoEventName}_${getViewport()}` : videoEventName
    })

    if (trackVideoControls && type !== `percent`) {
      const id = player.id_
      const trackingNameParts = [document.getElementById(id).getAttribute('data-tracking-name') || id]
      trackingNameParts.push(videoEventName)
      if(getViewport()) {
        trackingNameParts.push(getViewport())
      }
      const trackingName = trackingNameParts.join('_')
      recordClick(`#${id}`, trackingName)
    }
  }

  function calculatePercent () {
    const currentTime = player.currentTime()
    const duration = player.duration()
    const percent = Math.round((currentTime / duration) * 100)

    if (percentiles.indexOf(percent) > -1) {
      if (percentTriggered['x' + percent] === false) {
        percentTriggered['x' + percent] = true
        player.trigger('percent', percent)
      }
    }
  }
}
